"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUserDocumentUploadDTOSchema = exports.UserDocumentUploadDTOSchema = exports.UserDocumentDTO = exports.UserDocumentDTOSchema = exports.UserDocumentSchema = exports.UserDocumentBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
exports.UserDocumentBaseSchema = zod_1.z.object({
    // Everything BUT yachtName MAY become a ref
    UploadUrl: zod_1.z.string(),
    DocumentType: zod_1.z.string(),
    YachtType: zod_1.z.string().optional(),
    YachtName: zod_1.z.string().optional(),
    Position: zod_1.z.string().optional(),
    Status: zod_1.z.string().default('Uploaded'),
    Expiry: zod_1.z.coerce.date().optional(),
    // Who's the document meant for
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // Who's uploading it
    AuthorId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Notes: zod_1.z.string().optional(),
});
exports.UserDocumentSchema = exports.UserDocumentBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.UserDocumentDTOSchema = exports.UserDocumentSchema.extend(__assign({ UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), AuthorId: (0, ObjectId_1.ObjectIdString)('Invalid UserId') }, CommonMongoModelFields_1.CommonModelDTOFields));
exports.UserDocumentDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Position: model.Position,
            Status: model.Status,
            DocumentType: model.DocumentType,
            YachtName: model.YachtName,
            YachtType: model.YachtType,
            UploadUrl: model.UploadUrl,
            UserId: model.UserId.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
            AuthorId: model.AuthorId.toString(),
            Author: (0, ObjectId_1.isPopulated)(model.AuthorId) ? User_1.UserDTO.convertFromModel(model.AuthorId) : undefined,
            Notes: model.Notes,
            Expiry: model.Expiry,
        };
        return dto;
    },
    convertToEditDTO: function (dto) {
        if (!dto)
            return {};
        var editDto = __assign(__assign({}, dto), { Expiry: !dto.Expiry ? '' : dto.Expiry.toString().length > 0 ? dto.Expiry.toISOString() : '' });
        return editDto;
    },
};
exports.UserDocumentUploadDTOSchema = exports.UserDocumentBaseSchema.omit({ UserId: true }).extend({
    UserId: zod_1.z.string(),
    AuthorId: zod_1.z.string(),
});
exports.EditUserDocumentUploadDTOSchema = exports.UserDocumentUploadDTOSchema.extend({
    _id: zod_1.z.string(),
    Expiry: zod_1.z.string().optional().default(''),
});
//# sourceMappingURL=UserDocument.js.map